import pick from 'lodash/pick';
import { parseLimit, parseOffset } from 'src/utils/pagination/listPagination';
import { DLPrefix } from './constants';
export const addDLPrefix = (path) => `${DLPrefix}${path}`;
export const removeDLPrefix = (deeplink) => {
    if (deeplink.startsWith(DLPrefix)) {
        return deeplink.split(DLPrefix)[1];
    }
    return deeplink;
};
const stringifyNode = (node) => JSON.stringify(pick(node, ['id', 'data', 'type']));
function isNode(data) {
    return !!data?.id;
}
const stringify = (data) => isNode(data) ? stringifyNode(data) : JSON.stringify(data);
export const objectParamsConfig = (paramNames) => {
    return {
        stringify: paramNames.reduce((result, param) => {
            result[param] = stringify;
            return result;
        }, {}),
        parse: paramNames.reduce((result, param) => {
            // Deep links sometimes pass raw scalars (e.g. navigatedFrom=QP_QUESTIONS)
            // that are not JSON. Fall back to the raw string instead of throwing.
            result[param] = (value) => {
                try {
                    return JSON.parse(value);
                }
                catch {
                    return value;
                }
            };
            return result;
        }, {}),
    };
};
const scalarStringify = (value) => value === undefined || value === null ? '' : String(value);
export const scalarParamsConfig = (paramNames) => {
    return {
        stringify: paramNames.reduce((result, param) => {
            result[param] = scalarStringify;
            return result;
        }, {}),
        parse: paramNames.reduce((result, param) => {
            result[param] = (value) => {
                if (param === 'offset') {
                    return parseOffset(value);
                }
                if (param === 'limit') {
                    return parseLimit(value);
                }
                return value;
            };
            return result;
        }, {}),
    };
};
export function mergePathConfig(objectParamNames, scalarParamNames = []) {
    const objectConfig = objectParamsConfig(objectParamNames);
    const scalarConfig = scalarParamsConfig(scalarParamNames);
    return {
        stringify: {
            ...objectConfig.stringify,
            ...scalarConfig.stringify,
        },
        parse: {
            ...objectConfig.parse,
            ...scalarConfig.parse,
        },
    };
}
